import * as React from "react";
import { Query } from "react-apollo";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";

// GraphQL
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import BackendWrapper from "../../Components/Layouts/BackendWrapper";

import Card from "../../Components/Card";
import DashboardSummaries from "./DashboardSummaries";
import Charts from "./Charts";
import WorkOrders from "./WorkOrders";
import Requests from "./Requests";

// Utils
import { getUserId } from "../../Utils/Helpers";

const userId = getUserId().userId;

const DashboardHeader = styled.h6`
  margin-left: 20px;
  margin-right: 20px;
`;

export default class Dashboard extends React.Component<{}> {
  render() {
    return (
      <Query query={GetUserDetails} variables={{ id: userId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the user details</div>;
          }

          const companyId = data.User.company.id;

          return (
            <BackendWrapper>
              <Card
                heading="Current activity"
                body={<DashboardSummaries companyId={companyId} />}
              />
              <Charts companyId={companyId} />
              <br />
              <br />
              <DashboardHeader>Recent Work Orders</DashboardHeader>
              <br />
              <br />
              <WorkOrders companyId={companyId} />
              <br />
              <br />
              <br />
              <br />
              <DashboardHeader>Recent Customer Requests</DashboardHeader>
              <br />
              <br />
              <Requests companyId={companyId} />
              <Helmet title="Dashboard" />
            </BackendWrapper>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/index.tsx